import { FallbackProps } from 'react-error-boundary';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-100 mx-auto mb-4">
            <AlertCircle className="w-6 h-6 text-red-600" />
          </div>

          <h2 className="text-center text-2xl font-bold text-gray-900 mb-2">
            <FormattedMessage
                id="error.title"
                defaultMessage="Что-то пошло не так"
            />
          </h2>

          <p className="text-center text-gray-600 mb-6">
            <FormattedMessage
                id="error.description"
                defaultMessage="Произошла ошибка при обработке вашего запроса. Пожалуйста, попробуйте снова."
            />
          </p>

          {process.env.NODE_ENV === 'development' && (
              <div className="bg-red-50 rounded-lg p-4 mb-6">
                <p className="text-sm font-mono text-red-600 break-words">
                  {error.message}
                </p>
              </div>
          )}

          <div className="flex justify-center">
            <button
                onClick={resetErrorBoundary}
                className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              <FormattedMessage
                  id="error.retry"
                  defaultMessage="Попробовать снова"
              />
            </button>
          </div>
        </div>
      </div>
  );
}
